<template>
  <div class="row">
    <div class="col-12">
      <h4 class="fs-20 fw-semibold mb-25">Find Your Answer Here</h4>
    </div>
    <div class="col-lg-6 mb-md-15">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              What is your return policy?
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              How can I track my order?
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              What payment methods do you accept?
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              Do you offer international shipping?
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFive">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              What is the shipping cost and delivery time?
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSix">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              Can I cancel my order before it ships?
            </button>
          </h2>
          <div
            id="collapseSix"
            class="accordion-collapse collapse"
            aria-labelledby="headingSix"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="accordion" id="accordionExample_two">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSeven">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSeven"
              aria-expanded="false"
              aria-controls="collapseSeven"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              Do you offer gift wrapping or packaging options?
            </button>
          </h2>
          <div
            id="collapseSeven"
            class="accordion-collapse collapse"
            aria-labelledby="headingSeven"
            data-bs-parent="#accordionExample_two"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingEight">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEight"
              aria-expanded="false"
              aria-controls="collapseEight"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              How do I contact your customer support?
            </button>
          </h2>
          <div
            id="collapseEight"
            class="accordion-collapse collapse"
            aria-labelledby="headingEight"
            data-bs-parent="#accordionExample_two"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingNine">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseNine"
              aria-expanded="false"
              aria-controls="collapseNine"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              Are there any discounts or promotions currently available?
            </button>
          </h2>
          <div
            id="collapseNine"
            class="accordion-collapse collapse"
            aria-labelledby="headingNine"
            data-bs-parent="#accordionExample_two"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTen">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTen"
              aria-expanded="false"
              aria-controls="collapseTen"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              Can I return an item without the original packaging?
            </button>
          </h2>
          <div
            id="collapseTen"
            class="accordion-collapse collapse"
            aria-labelledby="headingTen"
            data-bs-parent="#accordionExample_two"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingEleven">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEleven"
              aria-expanded="false"
              aria-controls="collapseEleven"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              Do you have a loyalty program or rewards system?
            </button>
          </h2>
          <div
            id="collapseEleven"
            class="accordion-collapse collapse"
            aria-labelledby="headingEleven"
            data-bs-parent="#accordionExample_two"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThirteen">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThirteen"
              aria-expanded="false"
              aria-controls="collapseThirteen"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              What is your sizing chart for clothing and shoes?
            </button>
          </h2>
          <div
            id="collapseThirteen"
            class="accordion-collapse collapse"
            aria-labelledby="headingThirteen"
            data-bs-parent="#accordionExample_two"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFourteen">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFourteen"
              aria-expanded="false"
              aria-controls="collapseFourteen"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              Can I request a custom order or personalized product?
            </button>
          </h2>
          <div
            id="collapseFourteen"
            class="accordion-collapse collapse"
            aria-labelledby="headingFourteen"
            data-bs-parent="#accordionExample_two"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFifteen">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFifteen"
              aria-expanded="false"
              aria-controls="collapseFifteen"
            >
              <span>
                <img
                  src="../../../assets/img/icons/down-arrow-blue.svg"
                  alt="Image"
                  class="plus"
                />
                <img
                  src="../../../assets/img/icons/up-arrow-ash.svg"
                  alt="Image"
                  class="minus"
                />
              </span>
              Are there any restrictions on international orders?
            </button>
          </h2>
          <div
            id="collapseFifteen"
            class="accordion-collapse collapse"
            aria-labelledby="headingFifteen"
            data-bs-parent="#accordionExample_two"
          >
            <div class="accordion-body">
              <p>
                Upon entering our practice, we hope you feel like you’re in good
                hands. Our modern, high energy practice is both relaxing and
                advanced, offering you the best possible care for natural
                health.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FaqAccordion",
};
</script>

<style lang="scss" scoped>
.accordion-item {
  border: none;
  margin: 0 0 12px;
  background: var(--whiteColor);
  &:last-child {
    margin-bottom: 0;
  }
  .accordion-header {
    margin-bottom: 0;
    position: relative;
    z-index: 3;
    .accordion-button {
      border-radius: 5px 5px 0 0;
      margin: 0;
      font-size: 16px;
      line-height: 26px;
      font-weight: 500;
      color: var(--titleColor);
      text-align: left;
      align-items: center;
      border: none;
      padding: 17px 50px 17px 25px;
      border-radius: 5px;
      transition: var(--transition);
      background-color: transparent;
      &:after {
        display: none;
      }
      &:focus {
        outline: none;
        box-shadow: none;
      }
      &:not(.collapsed) {
        box-shadow: none;
        span {
          img {
            &.minus {
              visibility: visible;
              opacity: 1;
            }
            &.plus {
              visibility: hidden;
              opacity: 0;
            }
          }
        }
      }
      span {
        display: inline-block;
        width: 35px;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        text-align: center;
        img {
          position: absolute;
          top: 27px;
          right: 20px;
          display: block;
          margin: 0 auto;
          &.minus {
            visibility: hidden;
            opacity: 0;
          }
        }
      }
    }
  }
  .accordion-body {
    border-radius: 0 0 5px 5px;
    padding-bottom: 15px;
    padding: 12px 25px 48px;
    border: none;
    border-top: 1px solid #e0e8ee;
    p {
      margin: 0 0 10px;
      &:last-child {
        margin: 0;
      }
    }
  }
}
.accordion-collapse {
  border: none;
}
.accordion-button:not(.collapsed) span i.plus {
  visibility: hidden;
  opacity: 0;
}
.accordion-button:not(.collapsed) span i.minus {
  visibility: visible !important;
  opacity: 1 !important;
}
</style>